// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.tip-text[data-v-b4ff692e] {\r\n  color: #909399;\r\n  font-size: 12px;\n}\n.error-text[data-v-b4ff692e] {\r\n  color: #f56c6c;\n}\n.mb10[data-v-b4ff692e] {\r\n  margin-bottom: 10px;\n}\n.mb20[data-v-b4ff692e] {\r\n  margin-bottom: 20px;\n}\n.ml10[data-v-b4ff692e] {\r\n  margin-left: 10px;\n}\r\n", ""]);
// Exports
module.exports = exports;
